import Vue from 'vue'
import VueI18n from 'vue-i18n';
import App from './App.vue'
import store from './store/index.js'
import './assets/fonts/kenteken.css';
import { languages, defaultLocale } from "@/locales";
import {initializeGoogleOptimize} from "./store/modules/ab-testing";

import "./scss/app.scss";
import './scss/_conflicts.scss';

Vue.use(VueI18n);

const messages = Object.assign(languages);

let language = new URLSearchParams(window.location.search).get('language') || defaultLocale;

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: defaultLocale,
  messages
})
export const locale = i18n.locale;

Vue.config.productionTip = false

new Vue({
  store,
  i18n,
  render: h => h(App),
  created: () => {
    store.commit("init");
  },
}).$mount('#app')

initializeGoogleOptimize(store);
